/*
 * Predefined themes list
 *
 * A theme is just a plain object with all desired properties (colours, fonts, padding, ...).
 * The "default" theme is mandatory, and is the default fallback if:
 *  1) no theme was selected
 *  2) a unknown theme was selected (themes are selected by name, i.e. property name in this constant)
 */
export default {
    default: {
        text: '#125651',
        font: {
            regular: '"Atlas Grotesk Regular", sans-serif',
            title: '"Atlas Grotesk Medium", sans-serif',
        },
        colour: {
            primary: '#30B79C',
            dark: '#125651',
        },
        chartsPalette: {
            blue: '#5669E2',
            purple: '#CF56E3',
            red: '#E45567',
            yellow: '#E2CF56',
            green: '#68E357',
            cyan: '#57E2CF',
            lightBlue: '#57AEE3',
            violet: '#8B56E2',
            pink: '#E256AD',
            orange: '#E38955',
            lime: '#AEE357',
            paleGreen: '#56E289',
            black: '#000000',
        },
    },
};
